import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { stripHTMLFromContent, updateInternalURLsToURIs } from '../../utils/stringOps'

const ShowInBrief = ({ inBrief, stripHTML }) => {
  if (inBrief !== 'not set') {
    return <>
      <div className='article-inBrief'>
        <div dangerouslySetInnerHTML={
          {
            __html: stripHTML ? stripHTMLFromContent(inBrief
              .replace(/ \(see <a\b[^>]*>(.*?)<\/a>\)/ig, '')
              .replace(/ \(see&nbsp;<a\b[^>]*>(.*?)<\/a>\)/ig, ''))
              : updateInternalURLsToURIs(inBrief, process.env.APP_BASE_URL)
          }
        }
        />
      </div>
    </>
  } else {
    return <>
      <div className='article-inBrief'><Skeleton count={3} /></div>
    </>
  }
}

export default ShowInBrief
